import styled from "styled-components";

export const HomepageMainContainer = styled.div`
  font-family: Travels, Arial, Helvetica, sans-serif;
  height: 100%;
  min-height: 100vh;
  width: 100%;
  min-width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: #000;
  padding: 0 6.3rem;
  overflow: auto;                          
  @media(max-width: 1024px) {
    padding: 0 3rem;
  }
`

export const HeadersContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  font-family: Travels, Arial, Helvetica, sans-serif;
  gap: 1.1rem;
  width: 100%;
    @media (max-width: 1024px) {
        width: 100%;
    }

`

export const ButtonsMainContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 3.2rem;

  @media (max-width: 800px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1.8rem;
    width: 100%;
  }
`

export const LogoContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 2rem;

  @media (max-width: 800px) {
    align-items: start;
    justify-content: space-between;
  }
`

export const LogoAndLangContainer = styled.div`
   padding-top: 50px;
   width: 100%;
   display: flex;
   justify-content: space-between;
   align-items: center;
   margin-bottom: 6.3rem;

   @media (max-width: 1024px) {
     padding-top: 30px;
     flex-direction: row;
     justify-content: space-between;
     align-items: flex-start;
   }
   @media (max-width: 800px) {
     margin-bottom: 2rem;
   }
`
export const ButtonsAndHeadersContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 3rem;
  padding-bottom: 3rem;
  @media (max-width: 800px) {
    justify-content: flex-start;
    padding-bottom: 0;
    gap: 2rem;
  }
`

export const SwitchLanguage = styled.div`
   display: flex;
   flex-direction: row;
   justify-content: center;
   align-items: center;
   gap: 20px;

   @media (max-width: 1024px) {
     display: flex;
     flex-direction: column;
       justify-content: center;
       align-items: center;
     gap: 15px;
   }
`

export const SocialIconsContainer = styled.div`
   display: none;

   @media (max-width: 800px) {
     display: flex;
     flex-direction: row;
     gap: 12px;
     justify-content: center;
     width: 100%;
   }
`

export const QRContainer = styled.div`
  position: relative;
  width: 30%;
  @media (max-width: 800px) {
    width: 100%;
  }
`

export const GirlImage = styled.img`
  width: 75%;
  position: absolute;
  bottom: 20px;
  right: -20px;

  @media (max-width: 800px) {
    display: none;
  }
`

export const QrImage = styled.img`
  width: 39%;
  position: absolute;
  bottom: 10px;
  right: 0;

  @media (max-width: 800px) {
    display: none;
  }
`

export const BodyContainer = styled.div`
  width: 100%;
  min-height: 54vh;                        
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 0.5rem;

  @media (max-width: 800px) {
    flex-direction: column;
    min-height: auto;
    margin-bottom: 0;
  }
`

export const LogoRC = styled.img`
  width: 20%;
  @media (max-width: 800px) {
    width: 60%
  }
`

export const FooterContainer = styled.footer`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  font-family: Travels, Arial, Helvetica, sans-serif;
  font-size: 14pt;
  line-height: 1.3;
  color: #666;
  padding-bottom: 1.5rem;
  margin-top: auto;                        

  @media (max-width: 1024px) {
    font-size: 12pt;
  }

  @media (max-width: 800px) {
    font-size: 11pt;
    gap: 0.1rem;
    padding-top: 3rem;
    padding-bottom: 1rem;
    margin-top: 0;
  }

  @media (max-width: 400px) {
    font-size: 10pt;
  }
`

export const FooterLine = styled.p`
  margin: 0;
  line-height: 1.3;
`